import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OrderModel } from '@shared/models/data/order-model';
import { NavService } from '@shared/services/nav.service';
import { UserProfileService } from '@shared/services/user-profile.service';

@Component({
  selector: 'aaos-products-table',
  templateUrl: './products-table.component.html',
  styleUrls: ['./products-table.component.scss']
})
export class ProductsTableComponent implements OnInit {

  loading = true;
  dataSource: MatTableDataSource<OrderModel>;
  columnsToDisplay = ['productShortName', 'orderDate', 'seatQuantity', 'actualBalanceAmmount'];
  @Input() orders: any = new Map<string, Array<OrderModel>>();
  constructor(
    private navService: NavService,
    private userProfileService: UserProfileService) {this.dataSource = new MatTableDataSource(); }

  ngOnInit() {
    this.orderByOrderLineNumber();
    this.dataSource.data = this.orders?.value;
    this.loading = false;
  }

  goToProductPage(product: string) {
    const path = this.userProfileService.productPathFinder(product);
    this.navService.goToPath(path);

  }

  orderByOrderLineNumber() {
    this.orders?.value?.sort((a, b) => a.orderLineNumber - b.orderLineNumber);
  }

}
